import { Box, Stack, Typography } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';

import { Locales } from '@/models/User';
import { GridLocaleTextOverride } from '@/utils/dataGridUtil';

import { ApplicantDashboardRow } from './ApplicantDashboardTypes';

interface DashboardDataGridSectionProps {
  locale: Locales | null;
  rows: ApplicantDashboardRow[];
  columns: GridColDef[];
  title: string;
  emptyMessage: string;
}

function DashboardDataGridSection({
  locale,
  rows,
  columns,
  title,
  emptyMessage,
}: DashboardDataGridSectionProps) {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      paddingTop={{ xs: '16px', md: '12px' }}
      flex='1 1 auto'
      minHeight={0}
      width='100%'
    >
      <Typography
        variant='h2'
        style={{
          flex: '0 1 auto',
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          marginTop: '10px',
          marginBottom: '20px',
          width: '100%',
          boxSizing: 'border-box',
          paddingX: { xs: '12px', sm: '20px' },
          flex: '1 1 auto',
          minHeight: { xs: 320, md: 360 },
          overflowX: { xs: 'auto', md: 'hidden' },
          maxWidth: '100%',
        }}
      >
        <DataGridPremium
          localeText={GridLocaleTextOverride(locale)}
          initialState={{
            density: 'compact',
            columns: {
              columnVisibilityModel: {
                applicationTypeId: false,
                status: false,
              },
            },
          }}
          pagination
          autoPageSize
          rows={rows}
          columns={columns}
          slots={{
            noRowsOverlay: () => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                <div>{emptyMessage}</div>
              </Stack>
            ),
          }}
        />
      </Box>
    </Box>
  );
}

export default DashboardDataGridSection;
